export const dados = {
  imgbaseurl: "https://gestorderotasapi.webi9.com.br/files/"
}